import { Link } from "react-router-dom";
import { getCategories } from "../../../services/Api";
import { useEffect, useState } from "react";
const Menu = () => {
    const [categories, setCategories]=useState([]);
    useEffect(()=>{
        getCategories({})
        .then(({data})=>{
            setCategories(data.data.docs);
            // console.log(categories);
        })
        .catch((error)=>console.log(error))
    },[]);
    return (
        <nav>
            <div id="menu" className="collapse navbar-collapse">
                <ul>
                    {
                        categories.map((item)=>{
                            return (
                                <li className="menu-item"><Link to={`/Category-${item._id}`}>{item.title}</Link></li>
                            )
                        })
                    }
                </ul>
            </div>
        </nav>
    )
}
export default Menu;
